import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Link } from "react-router";
import { apiFetch } from "@/lib/api";
import { useAuth } from "@/app/auth-context";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "@/hooks/use-toast";

export function MyProfilePage() {
  const { me } = useAuth();
  const [s, setS] = useState({ firstName: "", lastName: "", phone: "", mobile: "", signature: "" });
  const patch = useMutation({
    mutationFn: (req: typeof s) => apiFetch("/api/me", { method: "PATCH", body: JSON.stringify(req) }),
    onSuccess: () => toast.success("Profile saved"),
  });
  const enableMfa = useMutation({
    mutationFn: () => apiFetch<{ otpAuthUri: string; secret: string }>("/api/me/mfa/enable", { method: "POST" }),
  });

  return (
    <div className="space-y-6 p-6">
      <h1 className="text-2xl font-semibold">My profile {me?.displayName ? `— ${me.displayName}` : ""}</h1>
      <form onSubmit={(e) => { e.preventDefault(); patch.mutate(s); }} className="grid max-w-2xl grid-cols-1 gap-3 md:grid-cols-2">
        <div><Label htmlFor="fn">First name</Label><Input id="fn" value={s.firstName} onChange={(e) => setS({ ...s, firstName: e.target.value })} /></div>
        <div><Label htmlFor="ln">Last name</Label><Input id="ln" value={s.lastName} onChange={(e) => setS({ ...s, lastName: e.target.value })} /></div>
        <div><Label htmlFor="ph">Phone</Label><Input id="ph" value={s.phone} onChange={(e) => setS({ ...s, phone: e.target.value })} /></div>
        <div><Label htmlFor="mo">Mobile</Label><Input id="mo" value={s.mobile} onChange={(e) => setS({ ...s, mobile: e.target.value })} /></div>
        <div className="md:col-span-2"><Label htmlFor="sig">Signature (HTML)</Label><Input id="sig" value={s.signature} onChange={(e) => setS({ ...s, signature: e.target.value })} /></div>
        <div className="md:col-span-2"><Button type="submit" disabled={patch.isPending}>Save profile</Button></div>
      </form>

      <div className="space-y-2">
        <h2 className="text-xl font-medium">Security</h2>
        <Link to="/me/password" className="text-sm text-primary underline">Change password</Link>
        <div>
          {me?.mfaEnabled
            ? <span>MFA is enabled.</span>
            : <Button onClick={() => enableMfa.mutate()}>Enable MFA</Button>}
          {enableMfa.data && (
            <pre className="mt-2 rounded border p-2 text-xs">otpauth URL: {enableMfa.data.otpAuthUri}{"\n"}secret: {enableMfa.data.secret}</pre>
          )}
        </div>
      </div>
    </div>
  );
}
